import Styled from "styled-components";

const orangeColor = "#FF9B15";

const HowItWorksWrap = Styled.div`
    .contents h5{
        font-weight: bold;
        font-size: 22px;
        margin-top: 8px;
        margin-bottom: 0px;
    }
    P{
        font-size: 14px;
    }
    .main-content{
        line-height: 40px;
        margin-top: 10px;
    }
    .contents{
        margin: 0px 120px 0px 120px;
    }
    .contents_heading{
        display: flex;
    }
    p.content {
        line-height: 1.5;
        margin-bottom: 0px;
    }
    .numbers1 .num{
        font-weight: bold;
        font-size: 32px;
        margin-top: 8px;
        color: ${orangeColor};
        opacity: 50%;
        position: relative;
    }
    .numbers1{
        display: flex;
    }
    .numbers1 .num1{
        font-weight: bold;
        font-size: 18px;
        margin-top: 16px; 
        right: 12px;
        color: ${orangeColor};
        position: relative;
        z-index: 2;
    }
    h6{
        font-weight: bold;
        margin-top: 25px;
        font-size: 18px;
    }
    @media (max-width: 800px){
        .card1 .iframe{
            margin-top: 40px;
            width: 340px;
            height: 190px;
        }
    }
    @media (max-width: 768px){
        .card1 .iframe{
            width: 100%;
            height: 170px;
        }
    }
    @media (max-width: 500px){
        .card1 .iframe{
            width: 100%;
            height: 170px;
        }
        .padder {
            padding: 0;
        }
    }
    @media(max-width: 1024px){
        .video{
            margin-right: 30px;
        }
        .card1 .iframe{
            max-width: 100%;
            height: 160px;
        }
    }
    @media (max-width: 768px){
        .contents{
            margin-left:30px;
            margin-right:30px;
        }
    }
`;

export default HowItWorksWrap;
